import { create } from "zustand";
import { SupervisorState, SupervisorActions } from "./types";

export const useSupervisorStore = create<SupervisorState & SupervisorActions>(
	(set) => ({
		isSupervisor: undefined,
		update: (isSupervisor: boolean) => set({ isSupervisor: isSupervisor }),
	})
);
